import { Navigate, Outlet, useLocation, useMatches, useNavigate } from 'react-router';

import { APP_PATH } from '@shared/config';
import { buildLoginPath } from '@shared/lib/redirect';
import { selectBootStatus, selectRole, useSession } from '@shared/session';
import { StatusScreen } from '@shared/ui/status-screen';

import { APP_TEXT } from '../config/app.text';
import { ACCESS, decideAccess, resolveRouteMeta } from './route-meta';

/**
 * 공통 가드. 라우트 메타를 읽어 통과 · 로그인으로 · 권한 없음을 정한다.
 * 로그인으로 보낼 때 지금 주소를 `redirect` 로 싣는다(내부 경로만).
 */
export function RouteGuard() {
  const matches = useMatches();
  const location = useLocation();
  const navigate = useNavigate();
  const status = useSession(selectBootStatus);
  const role = useSession(selectRole);

  const access = decideAccess(resolveRouteMeta(matches), { status, role });

  if (access === ACCESS.LOGIN && location.pathname === APP_PATH.login) {
    // 로그인 라우트가 아직 등록되지 않았다. 같은 주소로 다시 보내면 끝없이 돈다.
    return (
      <StatusScreen
        title={APP_TEXT.loginRequiredTitle}
        description={APP_TEXT.loginRequiredDescription}
      />
    );
  }

  if (access === ACCESS.LOGIN) {
    const current = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={buildLoginPath(APP_PATH.login, current)} replace />;
  }

  if (access === ACCESS.FORBIDDEN) {
    return (
      <StatusScreen
        title={APP_TEXT.forbiddenTitle}
        description={APP_TEXT.forbiddenDescription}
        action={{ label: APP_TEXT.goHome, onClick: () => void navigate(APP_PATH.root) }}
      />
    );
  }

  return <Outlet />;
}
